import './assets/index.scss';
import 'ant-design-vue/dist/antd.css'
import 'babel-polyfill';

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VeeValidate from 'vee-validate';
import Antd from 'ant-design-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies'
import Table from './components/table/'
import qs from 'qs'
import {
  install as utils
} from './utils'
window.process = process;
window.showguide = process.env.VUE_APP_SHOWGUIDE;
Vue.prototype.excelToExportUrl='https://www.showguide.cn/expoApi/Home/Api/exportCollectionXls?type=$type&token=$token'

Vue.use(utils)

axios.interceptors.request.use(function (config) {
  config.data = config.data || [];
  if (config.data && !config.data.token) {
    config.data.token = VueCookies.get('access-token');
  }
  if (config.method.toLocaleLowerCase() === 'post' && config.data instanceof Object) {
    config.data = qs.stringify(config.data);
    config.headers['content-type'] = 'application/x-www-form-urlencoded'
  }
  config.baseURL = config.baseURL || '/api/expoApi/Home/Api/';
  config.headers['token'] = VueCookies.get('tokens');
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  var res = response.data;
  !res.error && res.data && !!res.data.token && vm.$cookies.set("access-token", res.data.token, '7d', '/');

  if (!response.request.responseURL.includes('zzAccountInfo') && [10000, 10001].includes(res.error)) {
    //vm.$message.error(res.errorMsg);
    vm.$router.push({
      name: 'index'
    });
  }

  return { ...response.data,
    response
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});



Vue.component('s-table', Table);

Vue.use(VeeValidate);
Vue.use(Antd);
Vue.use(VueAxios, axios)
Vue.use(VueCookies)

Vue.config.productionTip = false

var vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')